import { QueryClient, UseMutationOptions, useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

export function createScopedMutation<TData = unknown, TError = unknown, TVariables = void, TContext = unknown>(
  getOptions: (
    queryClient: QueryClient,
    roomKey: string,
    jobKey: string,
    options?: UseMutationOptions<TData, TError, TVariables, TContext>
  ) => UseMutationOptions<TData, TError, TVariables, TContext>
) {
  const useScopedMutation = (
    roomKey: string,
    jobKey: string,
    options?: UseMutationOptions<TData, TError, TVariables, TContext>
  ) => useMutation(getOptions(useQueryClient(), roomKey, jobKey, options));

  const useScopedMutationBuilder = () => {
    const queryClient = useQueryClient();
    return useCallback(
      (roomKey: string, jobKey: string, options?: UseMutationOptions<TData, TError, TVariables, TContext>) => {
        return queryClient.getMutationCache().build(queryClient, getOptions(queryClient, roomKey, jobKey, options));
      },
      [queryClient]
    );
  };

  return { useScopedMutation, useScopedMutationBuilder };
}
